import {useNavigate} from "react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import React from "react";

export const NoRowsDialog = ({
                                 domain,
                                 path
                             }) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Typography variant="h5" sx={{textAlign: "center"}}>
                {`No ${path} yet!`}
            </Typography>
            <Button
                variant="text"
                color="primary"
                onClick={() => navigate(`/${path}/new`)}
                sx={{mt: 2}}
                endIcon={<ArrowRightAltIcon/>}
            >
                {`New ${domain}`}
            </Button>
        </Box>
    );
};